<!-- sidebar.component.html -->
<!-- <div class="sidebar bg-dark" [@sidebarAnimation]="(hoverSubject$|async) ? 'open' : 'closed'" [@sidebarAnimation_handheld]="handheldSidebarToggled ? 'open' : 'closed'" (mouseleave)="onMouseLeave()">
  <div class="sidebar-content" [ngClass]="{'show-tray': !isHandheld}">
    <div class="d-flex flex-column">
      <div class="mx-auto">
        <div class="d-flex px-1 border-bottom border-dark">
          <img src="https://assets.tdwilliamson.com/img/CircleMark-darkbkgd-PNG.png" alt="" width="70" height="70" alt="TDW" class="sidebar-brand-full mt-1" />
          <div class="d-flex flex-column mt-3">
            <span class="fs-5">Product Selector</span>
            <small>© T.D. Williamson All Rights Reserved</small>
          </div>
        </div>

      </div>

      <ul class="list-group list-group-flush">
        <li class="list-group-item bg-transparent text-nav pb-0 border-0 nav-item px-0 no-close" [class]="item.class" *ngFor="let item of menu" (click)="toggleSection.emit(item?.id ?? -1)">

          <a *ngIf="(item.children || []).length > 0 else noChildren" class="d-flex text-reset text-decoration-none px-3 py-2 no-close">
            <i class="fa pe-3" [class]="item.icon"></i>
            <span>{{item.name}}</span>
            <i class="fa ms-auto fa-chevron-down" [@chevron]="item.class === 'nav-active-parent' ? 'open' : 'closed'">
            </i>

          </a>
          <ng-template #noChildren>
            <a class="d-flex text-reset text-decoration-none px-3 py-2 no-close" [routerLink]="item.path">
              <i class="fa pe-3" [class]="item.icon"></i>
              <span>{{item.name}}</span>
              <i class="ms-auto"></i>
            </a>
          </ng-template>
          <ul class="list-group mt-1" id="menuItems" *ngIf="(item.children || []).length > 0 && (item.class==='nav-active-parent' || (expandedParents ?? []).indexOf(item?.id || -1) > -1)">
            <ng-container *ngFor="let child of item.children">
              <ng-container *ngIf="!!child.name else menuItem">
                <ng-container *ngTemplateOutlet="menuTitle"></ng-container>
              </ng-container>

              <ng-template #menuTitle>
                <li class="list-group-item bg-transparent border-0 px-4 no-close">
                  <small class="text-uppercase text-nav no-close">{{child.name}}</small>
                </li>
              </ng-template>

              <ng-template #menuItem>
                <li class="list-group-item text-nav bg-transparent border-0 px-0 py-2" *ngIf="!!child.icon && !!child.path else divider" [class]="child.class" draggable="true" [routerLink]="child.path">
                  <div class="d-flex">
                    <a class="d-flex text-reset text-decoration-none px-4 flex-fill no-close">
                      <i style="font-size: .8rem;" class="fa pe-3" [class]="child.icon"></i>
                      <small>{{child.name}}</small>
                    </a>
                  </div>
                </li>
              </ng-template>

              <ng-template #divider>
                <li class="list-group-item bg-transparent border-0 px-0 py-2">
                  <span class="foo"></span>
                </li>
              </ng-template>
            </ng-container>
          </ul>
        </li>
      </ul>
    </div>


  </div>
</div> -->
<!-- Button to toggle sidebar -->
<div class="tray bg-light border-end border-2" [@sidebarAnimation]="isOpen || !isHandheld ? 'open' : 'closed'">
  <div class="d-flex mx-auto">
    <div class="d-flex flex-column">
      <span class="mt-5">&nbsp;</span>
      <a [routerLink]="[item.path]" (click)="didNavigate.emit()" *ngFor="let item of menu" class="text-light mx-auto py-2 w-100 text-center nav-link border-bottom" [ngClass]="{
        'sidebar-active': (currentRoute??'') === (item.path)
        }" style="cursor: pointer; font-size: 1.25rem;">
        <div class="d-flex flex-column">
          <img class="menu-img mx-auto" [src]="item.imgSrc" alt="menu" width="40px">
          <small style="font-size: .6rem;" class="text-dark mx-auto text-uppercase">{{item.slug}}</small>
        </div>
      </a>
    </div>
  </div>
</div>

<!-- <ng-template #hamburger>
  <i class="hamburger fa-solid fa-bars fs-2 pointer position-absolute top-10 start-1 translate-middle z-1 text-dark" style="top: 2rem; left: 2rem;" (click)="toggleSideBar(); "></i>
</ng-template> -->
